import React from 'react';
import { Grid, Link } from '@mui/material';

export default function ProductLogo() {
  const avatar = '/bbqbw.png';

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      style={{ width: '100%', marginBottom: 16, marginTop: 6 }}
    >
      <Link href="https://www.bbqr.site">
        <img
          width={120}
          height={90}
          alt="Logo_BBQR"
          src={avatar}
          loading="lazy"
          decoding="async"
          style={{ width: 120, height: 90 }}
        />
      </Link>
    </Grid>
  );
}
